import { Session } from '../types'

export const sessions: Session[] = [
    // Dubai Active Show - Active Arena Sessions
    {
      id: 'das-1',
      title: 'Zumba Masterclass',
      description:
        "Perfect for Everybody and Every Body! Zumba® brings people together to sweat, smile, and move! How It Works: We mix low- and high-intensity moves for a fun, calorie-burning dance party. Once the Latin and global beats kick in, you'll forget it's even a workout. Benefits: A full-body session that boosts cardio, tones muscles, builds balance and flexibility, and fills you with energy and joy. Join the Party! Dance with top Zumba® Presenters in a free 60-minute class and discover why everyone loves Zumba®!",
      startTime: '10:00',
      endTime: '11:00',
      date: 'October 25, 2025',
      location: 'Active Arena',
      feature: 'active-arena',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/6b930fd1c5/zumba.jpg',
    },
    {
      id: 'das-2',
      title: 'UPLIFT X with Leana Deeb',
      description:
        'Join Leana on a full-body experience designed to challenge, energize, and inspire. This session combines a dynamic, high-intensity workout with a Q&A and reflection segment, giving you the opportunity to not only push your physical limits but also explore the mindset behind performance, wellness, and personal growth.',
      startTime: '12:00',
      endTime: '14:00',
      date: 'October 25, 2025',
      location: 'Active Arena',
      feature: 'active-arena',
      speaker: 'Leana Deeb',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/3ddd3a26b4/leana.png',
    },
    {
      id: 'das-3',
      title: 'Movement Experience with lululemon',
      description:
        'Join Us for a 75-Minute Movement Experience with Our lululemon Ambassadors. Move, strengthen, and restore with Amanda, Michele, and Raya in a class designed to nourish body and mind. Start with grounding breathwork and mobility led by Amanda, flow into energizing Pilates with Michele, then unwind with deep stretching and meditation guided by Raya. All levels welcome. Come as you are, leave feeling renewed.',
      startTime: '14:45',
      endTime: '16:00',
      date: 'October 25, 2025',
      location: 'Active Arena',
      feature: 'active-arena',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/54acf54d7b/lululemon-500-x-500-px.jpg',
    },
    {
      id: 'das-4',
      title: 'James Smith Business Mentorship Live',
      description:
        "This isn't just for personal trainers. If you want to grow your business online, learn social media, email marketing, and sales automation, join James for the Business Mentorship session plus an exclusive Meet & Greet at the Neutonic booth. * Limited spaces. Business Mentorship Ticket required.",
      startTime: '09:00',
      endTime: '14:00',
      date: 'October 26, 2025',
      location: 'Active Arena',
      feature: 'active-arena',
      speaker: 'James Smith',
      category: 'Business',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/02d57d8039/james-500-x500.jpg',
    },
    {
      id: 'das-5',
      title: 'SWK Bootcamp with Kayla Itsines',
      description:
        'Join me for a strength-focused full body workout designed to challenge your legs, arms and abs. This session combines lower-body power moves, upper-body strength builders, and core burners, all in one high-energy bootcamp. Expect a mix of dynamic exercises like lateral lunges, glute bridges, push ups, and planks, delivered in my signature style: simple, effective and results-driven. This workout is perfect if you want to sweat, feel strong, and have fun — no matter your fitness level.',
      startTime: '15:30',
      endTime: '17:30',
      date: 'October 26, 2025',
      location: 'Active Arena',
      feature: 'active-arena',
      speaker: 'Kayla Itsines',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/f6de4377f1/kayla.gif',
    },
    // Dubai Active Show - Main Fitness Stage Sessions (Day 1 - Oct 24)
    {
      id: 'mfs-1',
      title: 'Strong Nation®',
      description:
        'A high-intensity workout that combines bodyweight, muscle-conditioning, cardio, and plyometric training, all synced to powerful music. Every beat drives you to push harder, helping you build strength, burn calories, and unleash your full power.',
      startTime: '11:00',
      endTime: '11:30',
      date: 'October 24, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/cbc931a829/strong-nation.jpg',
    },
    {
      id: 'mfs-2',
      title: 'Zumba®',
      description:
        'Zumba® is perfect for everybody and every body! We take the "work" out of workout, by mixing low-intensity and high-intensity moves for an interval-style, calorie-burning dance fitness party. A total workout, combining all elements of fitness – cardio, muscle conditioning, balance and flexibility, boosting your energy and leaving you with a serious dose of awesome after every class.',
      startTime: '11:30',
      endTime: '12:00',
      date: 'October 24, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/6b930fd1c5/zumba.jpg',
    },
    {
      id: 'mfs-3',
      title: 'Booty blast & Core blast - by 700 Padel & Fitness Hub',
      description:
        'With 700 Booty Blast, you can define, sculpt, and create lean glutes and thighs. Core Blast is a 45-minute class designed to increase athletic performance and avoid back problems. Additionally, it will help you strengthen your core.',
      startTime: '12:00',
      endTime: '13:00',
      date: 'October 24, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/ad1c02995a/25.png',
    },
    {
      id: 'mfs-4',
      title:
        'Holistic Energy Fusion – Transforming Body & Mind with Alice Veglio',
      description:
        'This holistic workout blends the best of yoga, pilates, functional training, HIIT, and guided breathing & mindset exercises. The goal is to achieve a full physical and mental transformation — awakening energy, strength, balance, and clarity, all in one powerful session.',
      startTime: '13:00',
      endTime: '14:00',
      date: 'October 24, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      speaker: 'Alice Veglio',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/8c1b8dd10a/alice.png',
    },
    {
      id: 'mfs-5',
      title: 'Cardio Groove Nation by Gymnation',
      description:
        'With Cardio Groove, you are exposed to a whole new world of dance. With this class, you will break out of your comfort zone and learn the moves. Continuous repetition and muscle memory guarantee you will properly move to the groove and get the perfect beat.',
      startTime: '14:00',
      endTime: '15:00',
      date: 'October 24, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/6d2f98d7e8/class-banners.png',
    },
    {
      id: 'mfs-6',
      title: 'Strong Nation®',
      description:
        'A high-intensity workout that combines bodyweight, muscle-conditioning, cardio, and plyometric training, all synced to powerful music. Every beat drives you to push harder, helping you build strength, burn calories, and unleash your full power.',
      startTime: '16:00',
      endTime: '16:30',
      date: 'October 24, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/cbc931a829/strong-nation.jpg',
    },
    {
      id: 'mfs-7',
      title: 'Zumba®',
      description:
        'We take the "work" out of workout, by mixing low-intensity and high-intensity moves for an interval-style, calorie-burning dance fitness party. A total workout, combining all elements of fitness – cardio, muscle conditioning, balance and flexibility, boosting your energy and leaving you with a serious dose of awesome after every class.',
      startTime: '16:30',
      endTime: '17:00',
      date: 'October 24, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/6b930fd1c5/zumba.jpg',
    },
    // Main Fitness Stage - Day 2 (Oct 25)
    {
      id: 'mfs-8',
      title: 'Mobility and Core Strength Class with Annathletics',
      description:
        'Guiding you through exercises targeting all major muscle groups, beginning with gentle mobilizing movements to warm up the muscles. The mobility program helps reduce muscle tension, increase joint range of motion, enhance muscular coordination, improve blood circulation, and boost overall energy levels. In addition, core exercises build a strong and flexible core to support posture, strengthen the back, and improve balance and stability.',
      startTime: '11:00',
      endTime: '12:00',
      date: 'October 25, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/4b933d609a/23.png',
    },
    {
      id: 'mfs-9',
      title: 'Veo Elite: Strength Refined with Marwan Albanna',
      description:
        'Step into a powerful session designed to push limits and unlock peak performance. Led by Veo Elite Coach Marwan Albanna, this class combines progressive strength training techniques with functional movement patterns to refine power, endurance, and control.',
      startTime: '12:00',
      endTime: '13:00',
      date: 'October 25, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      speaker: 'Marwan Albanna',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/e5f33e625f/veo.png',
    },
    {
      id: 'mfs-10',
      title: 'Bare Motion 60 by Be Lenka',
      description:
        'The workout starts with a warmup and cardio to get everyone moving, followed by endurance and coordination drills to build stamina. Core focus strengthens stability with planks and shoulder taps before the high-energy Burpee Battle, where participants give their all to crown the winner. The session ends with a cool-down and celebration. Note: only up to 5 CPD points can be obtained on the 25th of October by attending the relevant sessions, with a minimum of 5 hours of session time.',
      startTime: '13:00',
      endTime: '14:00',
      date: 'October 25, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/829b9af7d0/20251001064431_readymade-garments-trading-llc-co_cropped.jpg',
    },
    {
      id: 'mfs-11',
      title: 'Get It Done with Bradley Simmonds',
      description:
        'Bradley will take you through a full body HIIT workout in his signature Get It Done style. This consists of a 30-minute bodyweight session to build cardiovascular fitness while performing functional movements to improve strength, balance, and mobility. The session starts with a mobility warmup and ends with an all-important stretch.',
      startTime: '14:00',
      endTime: '15:00',
      date: 'October 25, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      speaker: 'Bradley Simmonds',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/e13a9f2a1d/bradley.png',
    },
    {
      id: 'mfs-12',
      title: 'PFAS-free Workout with Olympian Sarah Lindsay',
      description:
        'Unleash your inner Olympian with this dynamic workout designed to push your limits. Suitable for all fitness levels, Sarah combines high-energy movements and endurance challenges to build strength, power, and confidence. This session will leave you feeling stronger, more resilient, and ready to conquer anything.',
      startTime: '16:00',
      endTime: '17:00',
      date: 'October 25, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      speaker: 'Sarah Lindsay',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/74d16d5346/24.png',
    },
    {
      id: 'mfs-13',
      title: 'Zumba®',
      description:
        'Perfect for everybody and every body! Each Zumba® class is designed to bring people together to sweat it out. We take the "work" out of workout, by mixing low-intensity and high-intensity moves for an interval-style, calorie-burning dance fitness party. Once the Latin and World rhythms take over, you\'ll see why Zumba® Fitness classes are often called exercise in disguise.',
      startTime: '17:00',
      endTime: '17:30',
      date: 'October 25, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/6b930fd1c5/zumba.jpg',
    },
    // Main Fitness Stage - Day 3 (Oct 26)
    {
      id: 'mfs-14',
      title: 'Strong Nation®',
      description:
        'A high-intensity workout that combines bodyweight, muscle-conditioning, cardio, and plyometric training, all synced to powerful music. Every beat drives you to push harder, helping you build strength, burn calories, and unleash your full power.',
      startTime: '11:00',
      endTime: '11:30',
      date: 'October 26, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/cbc931a829/strong-nation.jpg',
    },
    {
      id: 'mfs-15',
      title: 'Zumba®',
      description:
        'Perfect for everybody and every body! Each Zumba® class is designed to bring people together to sweat it out. We take the "work" out of workout, by mixing low-intensity and high-intensity moves for an interval-style, calorie-burning dance fitness party. Once the Latin and World rhythms take over, you\'ll see why Zumba® Fitness classes are often called exercise in disguise.',
      startTime: '11:30',
      endTime: '12:00',
      date: 'October 26, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/6b930fd1c5/zumba.jpg',
    },
    {
      id: 'mfs-16',
      title: 'BURN with FitReplublik',
      description:
        "BURN is a high-energy, full-body workout that combines strength, cardio, and endurance training for maximum results. Designed to torch calories, build lean muscle, and boost stamina, this class challenges you to push past your limits while keeping the energy fun and motivating. Whether you're a beginner or advanced, BURN will leave you sweating, stronger, and unstoppable.",
      startTime: '12:00',
      endTime: '13:00',
      date: 'October 26, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/7a1ba39797/fit-republik.png',
    },
    {
      id: 'mfs-17',
      title: 'LES MILLS BODYATTACK™',
      description:
        'LES MILLS BODYATTACK™ is a high-energy fitness class with moves that cater for total beginners to total addicts. It combines athletic movements like running, lunging and jumping with strength exercises such as push-ups and squats.',
      startTime: '13:00',
      endTime: '14:00',
      date: 'October 26, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/2aecb2c52b/les-milles-body-attack.png',
    },
    {
      id: 'mfs-18',
      title: 'TULA Strength',
      description:
        'An energizing and restorative practice that encourages you to move with intention and awareness. Combining fluid sequences, mindful breathing, and gentle strength work, Sabrina creates a soothing yet empowering atmosphere. This flow offers harmony of calm and vitality, leaving you refreshed and grounded.',
      startTime: '14:00',
      endTime: '15:00',
      date: 'October 26, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/60819a85aa/tula-strength.png',
    },
    {
      id: 'mfs-19',
      title: 'Barre by Fitness First',
      description:
        'Discover the transformative power of this ballet-inspired workout designed to sculpt, strengthen and empower. The class embraces elements of Pilates, focusing on posture, core stability and muscle endurance, all set to uplifting music.',
      startTime: '15:00',
      endTime: '16:00',
      date: 'October 26, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/d908d6f030/untitled-design-30.png',
    },
    {
      id: 'mfs-20',
      title: 'Zumba®',
      description:
        'Perfect for everybody and every body! Each Zumba® class is designed to bring people together to sweat it out. We take the "work" out of workout, by mixing low-intensity and high-intensity moves for an interval-style, calorie-burning dance fitness party. Once the Latin and World rhythms take over, you\'ll see why Zumba® Fitness classes are often called exercise in disguise.',
      startTime: '16:00',
      endTime: '17:00',
      date: 'October 26, 2025',
      location: 'Main Fitness Stage',
      feature: 'main-stage',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/6b930fd1c5/zumba.jpg',
    },
    // Dubai Active Talks Sessions - Day 1 (October 24, 2025)
    {
      id: 'dat-1',
      title: 'Unstoppable You – Turning Challenges into Confidence',
      description:
        "Discover how to transform life's challenges into stepping stones for building unshakeable confidence and resilience.",
      startTime: '10:15',
      endTime: '11:15',
      date: 'October 24, 2025',
      location: 'Dubai Active Talks Stage',
      feature: 'dubai-active-talks',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      speakers: [
        {
          name: 'Kim Shelar',
          title:
            'Leadership Energy Coach - for leaders that lead through Spirit & Energy',
          image:
            'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'dat-2',
      title: 'Q&A with UAE Future Champions',
      description:
        'Engage with rising UAE athletic stars as they share their journeys, challenges, and insights on achieving excellence in competitive sports.',
      startTime: '11:15',
      endTime: '11:45',
      date: 'October 24, 2025',
      location: 'Dubai Active Talks Stage',
      feature: 'dubai-active-talks',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      speakers: [
        {
          name: 'Hanin Imran',
          title: 'Wellness Consultant',
          image:
            'https://a.storyblok.com/f/282702/500x500/eb221324e4/hanin.gif',
          role: 'Moderator',
        },
        {
          name: 'Ava Hall',
          title: 'Athlete and SHE RUN Champion',
          image:
            'https://a.storyblok.com/f/282702/500x500/7461e00e56/ava-hall.png',
        },
        {
          name: 'Laila Labib',
          title: 'Athlete and SHE RUN Champion',
          image:
            'https://a.storyblok.com/f/282702/500x500/4cf0118ae0/laila.png',
        },
      ],
    },
    {
      id: 'dat-3',
      title:
        'Stretch & Breathwork Flow Session to Boost Confidence, Calm & Center',
      description:
        'Experience a guided session combining stretching and breathwork techniques designed to enhance confidence, promote calmness, and center your mind.',
      startTime: '11:45',
      endTime: '12:45',
      date: 'October 24, 2025',
      location: 'Dubai Active Talks Stage',
      feature: 'dubai-active-talks',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      speakers: [
        {
          name: 'Hanin Imran',
          title: 'Wellness Consultant',
          image:
            'https://a.storyblok.com/f/282702/500x500/eb221324e4/hanin.gif',
          role: 'Presenter',
        },
      ],
    },
    // Dubai Active Talks Sessions - Day 3 (October 26, 2025)
    {
      id: 'dat-4',
      title: 'Fast Weight Loss Era: Shortcut or Shift?',
      description:
        'Panel discussion examining modern weight loss trends, exploring whether rapid results represent genuine health shifts or potentially harmful shortcuts.',
      startTime: '11:00',
      endTime: '11:30',
      date: 'October 26, 2025',
      location: 'Dubai Active Talks Stage',
      feature: 'dubai-active-talks',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      speakers: [
        {
          name: 'Suchitra Sivasankaran',
          title: 'Chief Visionary Officer, Inside&Out™',
          image:
            'https://a.storyblok.com/f/282702/640x640/4fcd3026a0/suchtira.gif',
        },
        {
          name: 'Dr. Hasia',
          title: 'Aesthetic Doctor',
          image:
            'https://a.storyblok.com/f/282702/500x500/2fd83567d4/dr-hasia.gif',
        },
        {
          name: 'Mitun De Sarkar',
          title: 'Clinical Dietitian, Founder, Simply Healthy',
          image:
            'https://a.storyblok.com/f/282702/500x500/c3a2dd55b8/mitun.gif',
        },
        {
          name: 'Lucas Aoun',
          title: "Australia's Leading Biohacker, Mens Health Expert",
          image:
            'https://a.storyblok.com/f/282702/500x500/47d9082c3d/lucas.gif',
        },
        {
          name: 'Zena Habi',
          title: 'Lifestyle Wellness Consultant',
          image:
            'https://a.storyblok.com/f/282702/500x500/8725c8c06b/zena-habi.jpg',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'dat-5',
      title: 'Longevity Simplified',
      description:
        'Practical insights and actionable strategies for living a longer, healthier life without overwhelming complexity.',
      startTime: '11:30',
      endTime: '12:00',
      date: 'October 26, 2025',
      location: 'Dubai Active Talks Stage',
      feature: 'dubai-active-talks',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      speakers: [
        {
          name: 'Dr. Shefali Verma',
          title: 'Owner, Doctor Shefali Consultancy',
          image:
            'https://a.storyblok.com/f/282702/500x500/0da73f147c/dr-shefali.gif',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'dat-6',
      title:
        'The Age Factor: Boosting Fitness in Your 20s, 40s, 60s and Beyond',
      description:
        'Expert panel discussing age-appropriate fitness strategies and how to optimize health and performance at every life stage.',
      startTime: '12:00',
      endTime: '12:30',
      date: 'October 26, 2025',
      location: 'Dubai Active Talks Stage',
      feature: 'dubai-active-talks',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      speakers: [
        {
          name: 'Perri Shakes-Drayton',
          title: 'Olympian',
          image:
            'https://a.storyblok.com/f/282702/500x500/02a219a7c6/perri.gif',
        },
        {
          name: 'Sara Lodhi',
          title:
            'NASM Level 3 Personal Trainer & Coach, Representative of ASICS',
          image:
            'https://a.storyblok.com/f/282702/500x500/969b06a7a5/sara-lodhi.gif',
        },
        {
          name: 'Hanin Imran',
          title: 'Wellness Consultant',
          image:
            'https://a.storyblok.com/f/282702/500x500/eb221324e4/hanin.gif',
        },
        {
          name: 'Lisa Campbell',
          title: 'Founder of Ultimate Athletics',
          image:
            'https://a.storyblok.com/f/282702/500x500/a46d2a65fc/lisa-campell.png',
        },
        {
          name: 'Kim Shelar',
          title: 'Leadership Energy Coach',
          image:
            'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'dat-7',
      title: 'In Conversation with Bradley Simmonds and Diren Kartel',
      description:
        'Intimate conversation with two fitness industry leaders sharing their experiences, philosophies, and insights on training, motivation, and success.',
      startTime: '12:30',
      endTime: '13:30',
      date: 'October 26, 2025',
      location: 'Dubai Active Talks Stage',
      feature: 'dubai-active-talks',
      category: 'Fitness',
      isBooked: false,
      eventId: 'active',
      speakers: [
        {
          name: 'Bradley Simmonds',
          title:
            'Transformation Coach | Fitness Expert | Founder of Get It Done',
          image:
            'https://a.storyblok.com/f/282702/500x500/f11539d824/untitled-design-28.png',
        },
        {
          name: 'Diren Kartel',
          title:
            'Veteran Fitness Coach, Content Creator & Motivational Speaker',
          image:
            'https://a.storyblok.com/f/282702/500x500/49c17912cf/untitled-design-27.png',
        },
      ],
    },
    {
      id: 'dat-8',
      title: 'Modesty: Movement in Fitness',
      description:
        'Panel exploring inclusive fitness practices that respect cultural values and modesty while promoting active, healthy lifestyles.',
      startTime: '13:30',
      endTime: '14:00',
      date: 'October 26, 2025',
      location: 'Dubai Active Talks Stage',
      feature: 'dubai-active-talks',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      speakers: [
        {
          name: 'Noor B',
          title: 'Founder and CEO of Humble Power',
          image:
            'https://a.storyblok.com/f/282702/500x500/24595afa89/noor-b.png',
        },
        {
          name: 'Jenna Khalife',
          title:
            'Founder & Head Coach of Swish: The only female-run basketball community in the UAE',
          image:
            'https://a.storyblok.com/f/282702/500x500/a0ce48bf08/jenna.png',
        },
        {
          name: 'Hessa Ali Alkubaisi',
          title: 'Emirati OCR Athlete & coach',
          image:
            'https://a.storyblok.com/f/282702/500x500/910731a97e/hessa-ali-alkubaisi.png',
        },
        {
          name: 'Rawan Mohab',
          title: 'Athlete & member of the UAE association of Squash',
          image:
            'https://a.storyblok.com/f/282702/500x500/ae9a99bed8/rawan-mohab.png',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'dat-9',
      title:
        'How is your Gut Health? The Surprising Ways Your Stomach Runs the Show',
      description:
        'Discover the critical connection between gut health and overall wellness, exploring how your digestive system impacts everything from mood to immunity.',
      startTime: '14:00',
      endTime: '14:30',
      date: 'October 26, 2025',
      location: 'Dubai Active Talks Stage',
      feature: 'dubai-active-talks',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      speakers: [
        {
          name: 'Mitun De Sarkar',
          title: 'Clinical Dietitian, Founder, Simply Healthy',
          image:
            'https://a.storyblok.com/f/282702/500x500/c3a2dd55b8/mitun.gif',
        },
        {
          name: 'Yash Moradiya',
          title: '10x Guinness World Record Holder, Yogipreneur',
          image:
            'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
        },
        {
          name: 'Maha Rouabhia',
          title: 'Founder of Zensoma | 53 years young',
          image:
            'https://a.storyblok.com/f/282702/500x500/40f27a34c1/maha-rouabhia.png',
        },
        {
          name: 'Stephen Julius Delpino',
          title: 'Head - International Business Expansion, Meals On Me',
          image:
            'https://a.storyblok.com/f/282702/500x500/184d7b0831/untitled-design-42.png',
        },
        {
          name: 'Mitun De Sarkar',
          title: 'Clinical Dietitian, Founder, Simply Healthy',
          image:
            'https://a.storyblok.com/f/282702/500x500/c3a2dd55b8/mitun.gif',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'dat-10',
      title: 'Real Over Perfect: The Anti-Burnout Wellness Talk We All Needed',
      description:
        'Honest conversation about sustainable wellness, rejecting perfectionism, and building realistic habits that prevent burnout.',
      startTime: '14:30',
      endTime: '15:30',
      date: 'October 26, 2025',
      location: 'Dubai Active Talks Stage',
      feature: 'dubai-active-talks',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      speakers: [
        {
          name: 'Dr. Shefali Verma',
          title: 'Owner, Doctor Shefali Consultancy',
          image:
            'https://a.storyblok.com/f/282702/500x500/0da73f147c/dr-shefali.gif',
        },
        {
          name: 'Allaoua Gaham',
          title: 'Wellbeing Consultant',
          image:
            'https://a.storyblok.com/f/282702/500x500/845cf368e3/untitled-design-14.png',
        },
        {
          name: 'Mariyam Thabet',
          title: 'Health and Fitness Influencer and PT',
          image:
            'https://a.storyblok.com/f/282702/500x500/3ee8e8a415/mariyam-thabet.png',
        },
        {
          name: 'Kim Shelar',
          title: 'Leadership Energy Coach',
          image:
            'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'dat-11',
      title: 'GO Sports: Battle of the Brands',
      description:
        'Dynamic panel featuring sports brand leaders discussing innovation, market trends, and the future of athletic retail in the region.',
      startTime: '16:00',
      endTime: '17:00',
      date: 'October 26, 2025',
      location: 'Dubai Active Talks Stage',
      feature: 'dubai-active-talks',
      category: 'Business',
      isBooked: false,
      eventId: 'active',
      speakers: [
        {
          name: 'Christoffer Jansen',
          title: 'General Manager',
          image:
            'https://a.storyblok.com/f/282702/500x500/8f83969563/untitled-design-33.png',
        },
        {
          name: 'Linda Imadojemun',
          title: 'Head of Marketing',
          image:
            'https://a.storyblok.com/f/282702/500x500/6e0cf832b2/untitled-design-34.png',
        },
        {
          name: 'Gary Morton',
          title: 'Head of Retail',
          image:
            'https://a.storyblok.com/f/282702/500x500/7e7cc8adc0/untitled-design-35.png',
        },
      ],
    },
    // Yoga & Pilates Studio Sessions - Day 1 (October 24, 2025)
    {
      id: 'yps-1',
      title: 'Tula Sculpt Pilates by Tula',
      description:
        'Tula Sculpt is a signature class designed by Tula studios to combine contemporary exercises with classical Pilates exercises. Participants can expect to feel full body burn, sculpt and toned as well as leaving the session energized and empowered.',
      startTime: '11:00',
      endTime: '12:00',
      date: 'October 24, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/8263b3307e/tula.png',
    },
    {
      id: 'yps-2',
      title: 'Circl Mobility™',
      description:
        "Based on the science of functional movement, CIRCL Mobility™ focuses on flexibility, breathwork, and mobility exercises. Whether you're a fitness enthusiast, a busy mom, or a 9-5er, CIRCL Mobility™ helps you release stress, restore your range of motion, and renew your ability to move better, longer.",
      startTime: '12:00',
      endTime: '13:00',
      date: 'October 24, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/3e9d25a6a3/circ-mobility-a-lee.jpg',
    },
    {
      id: 'yps-3',
      title: 'Cue and Communication Workshop for Pilates and Yoga Teachers',
      description:
        'This session explores effective communication strategies for Pilates and Yoga teachers, including DISC communication styles, instructional cues, analogies, imagery, and practical application with Pilates movements.',
      startTime: '13:00',
      endTime: '15:00',
      date: 'October 24, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Education',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/a3a5a56fb4/cue-and-communication.png',
    },
    {
      id: 'yps-4',
      title: 'Power & Poise Pilates with LVLUP',
      description:
        'A dynamic mat-based workout that builds core strength, refines posture, and enhances balance — leaving you empowered and centered in both body and mind.',
      startTime: '15:00',
      endTime: '16:00',
      date: 'October 24, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/22064884a5/untitled-design-41.png',
    },
    // Yoga & Pilates Studio Sessions - Day 2 (October 25, 2025)
    {
      id: 'yps-5',
      title: 'LES MILLS YOGA™',
      description:
        'LES MILLS YOGA™ blends traditional practice with modern guidance and uplifting music, leaving you calm, focused, and refreshed in this 45-minute session.',
      startTime: '11:00',
      endTime: '12:00',
      date: 'October 25, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/339c0d8518/les-mills-yoga.jpg',
    },
    {
      id: 'yps-6',
      title: 'Deep Stretching - by 700 Padel & Fitness Hub',
      description:
        'A deep stretching class using long-duration passive stretches, breathwork, and yoga-based poses to improve flexibility, mobility, and relaxation.',
      startTime: '12:00',
      endTime: '13:00',
      date: 'October 25, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/f91242b1e6/untitled-design-25.png',
    },
    {
      id: 'yps-7',
      title: 'Breathwork & Mindfulness for High Performance with Elise Riley',
      description:
        'An immersive session blending guided breathwork and meditation to reduce stress, enhance focus, and optimise recovery, inspired by techniques used by elite performers.',
      startTime: '13:00',
      endTime: '14:00',
      date: 'October 25, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/53addbfa75/elise-rileyy.jpg',
    },
    {
      id: 'yps-8',
      title: 'Yoga Flow with Sanjana Karia',
      description:
        'An energizing yet grounding yoga flow blending mindful movement, breathwork, and flow sequences designed to build strength, flexibility, and calm.',
      startTime: '14:00',
      endTime: '15:00',
      date: 'October 25, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/222d9e88a0/sanjana.png',
    },
    {
      id: 'yps-9',
      title: 'Mindful Motion with Sabrina Biljana',
      description:
        'A restorative mat Pilates session combining fluid sequences, mindful breathing, and gentle strength work for balance, grounding, and calm.',
      startTime: '15:00',
      endTime: '16:00',
      date: 'October 25, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/0e16c53fa9/sabrina-biljana.png',
    },
    {
      id: 'yps-10',
      title: 'Circl Mobility™',
      description:
        'A functional movement session focusing on flexibility, breathwork, and mobility to restore range of motion and reduce stress.',
      startTime: '16:00',
      endTime: '17:00',
      date: 'October 25, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/3e9d25a6a3/circ-mobility-a-lee.jpg',
    },
    // Yoga & Pilates Studio Sessions - Day 3 (October 26, 2025)
    {
      id: 'yps-11',
      title: 'Stretch Synergy: Partner-Assisted Mobility with Yash Moradiya',
      description:
        'An interactive partner-assisted mobility session designed to improve flexibility, body awareness, and connection.',
      startTime: '11:00',
      endTime: '12:00',
      date: 'October 26, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/a8e864693f/yash.png',
    },
    {
      id: 'yps-12',
      title: 'Yoga with VEO',
      description:
        'A rejuvenating yoga session blending mindful movement, breathwork, and deep stretches to release tension and build inner calm.',
      startTime: '12:00',
      endTime: '13:00',
      date: 'October 26, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image: 'https://a.storyblok.com/f/282702/500x500/e5f33e625f/veo.png',
    },
    {
      id: 'yps-13',
      title: 'Circl Mobility™',
      description:
        'A flexibility and movement session focused on restoring mobility, improving range of motion, and reducing stress.',
      startTime: '13:00',
      endTime: '14:00',
      date: 'October 26, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/3e9d25a6a3/circ-mobility-a-lee.jpg',
    },
    {
      id: 'yps-14',
      title: 'Myoflow with Fitness First',
      description:
        'A mobility-focused class blending myofascial release with yoga-inspired movement to unlock tight muscles and restore functional mobility.',
      startTime: '14:00',
      endTime: '15:00',
      date: 'October 26, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/1dcd6c2147/untitled-design-31.png',
    },
    {
      id: 'yps-15',
      title: 'Glow Flow with LVLUP',
      description:
        'A vibrant yoga sequence blending energizing movement with mindful breathwork to awaken your inner fire and release tension.',
      startTime: '15:00',
      endTime: '16:00',
      date: 'October 26, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/4b31c002e8/levelup-gym-yoga.jpg',
    },
    {
      id: 'yps-16',
      title: 'Age in Reverse - Your Blueprint to Lifelong Strength',
      description:
        'A 60-minute mind-body experience with Maha Rouabhia, blending resistance, mobility, balance training, and breathwork to help you "age in reverse".',
      startTime: '16:00',
      endTime: '17:00',
      date: 'October 26, 2025',
      location: 'Yoga & Pilates Studio',
      feature: 'yoga-pilates',
      category: 'Wellness',
      isBooked: false,
      eventId: 'active',
      image:
        'https://a.storyblok.com/f/282702/500x500/40f27a34c1/maha-rouabhia.png',
    },
    // Dubai Muscle Show Sessions
    {
      id: 'dms-1',
      title: 'Dubai Muscle Classic - Finals',
      description:
        "Watch the Middle East's biggest bodybuilding competition finals. Over AED70,000 in prize money with 17 PRO CARDS!",
      startTime: '14:00',
      endTime: '17:00',
      date: 'October 26, 2025',
      location: 'Main Stage',
      feature: 'muscle-classic',
      speaker: 'IFBB Pro Elite',
      category: 'Bodybuilding',
      isBooked: false,
      eventId: 'muscle',
    },
    {
      id: 'dms-2',
      title: 'Athlete Meet & Greet',
      description:
        'Meet Mr. Olympia champions! Get autographs, photos, and hear their success stories.',
      startTime: '16:00',
      endTime: '18:00',
      date: 'October 26, 2025',
      location: 'Booth C15',
      feature: 'meet-greet',
      speaker: 'Multiple Champions',
      category: 'Bodybuilding',
      isBooked: false,
      eventId: 'muscle',
    },
    // Dubai Muscle Talks Sessions - Day 2 (October 25, 2025)
    {
      id: 'dmt-1',
      title: 'Interview with CBUM',
      description:
        'A Canadian professional bodybuilder who dominated the Classic Physique division by winning the Mr. Olympia title six consecutive times from 2019 to 2024, a record in that category.',
      startTime: '11:00',
      endTime: '12:00',
      date: 'October 25, 2025',
      location: 'Dubai Muscle Talks Stage',
      feature: 'muscle-talks',
      category: 'Bodybuilding',
      isBooked: false,
      eventId: 'muscle',
      image:
        'https://a.storyblok.com/f/282702/500x500/df3384d7ee/chris-bumstead.jpg',
    },
    {
      id: 'dmt-2',
      title: 'Interview with Hany Rambod',
      description:
        'An American bodybuilding coach often nicknamed "The Pro Creator," famed for coaching athletes across multiple divisions to a combined total of 20-plus Olympia titles using his FST-7 training method.',
      startTime: '12:00',
      endTime: '13:00',
      date: 'October 25, 2025',
      location: 'Dubai Muscle Talks Stage',
      feature: 'muscle-talks',
      category: 'Bodybuilding',
      isBooked: false,
      eventId: 'muscle',
      image:
        'https://a.storyblok.com/f/282702/500x500/1c91d7bc97/hany-rambod.jpg',
    },
    {
      id: 'dmt-3',
      title: 'Interview with Dennis James',
      description:
        'A German-American retired IFBB professional bodybuilder known for his moniker "The Menace," who competed multiple times at Mr Olympia and now works as a coach and commentator in the sport.',
      startTime: '15:30',
      endTime: '16:30',
      date: 'October 25, 2025',
      location: 'Dubai Muscle Talks Stage',
      feature: 'muscle-talks',
      category: 'Bodybuilding',
      isBooked: false,
      eventId: 'muscle',
      image:
        'https://a.storyblok.com/f/282702/500x500/e30ec698b8/untitled-design-40.png',
    },
    {
      id: 'dmt-4',
      title: 'Interview with Flex Wheeler',
      description:
        'Kenneth "Flex" Wheeler is an American bodybuilding icon regarded as one of the most aesthetic ever, having won the Arnold Classic four times and finishing runner-up at Mr Olympia on several occasions.',
      startTime: '16:30',
      endTime: '17:30',
      date: 'October 25, 2025',
      location: 'Dubai Muscle Talks Stage',
      feature: 'muscle-talks',
      category: 'Bodybuilding',
      isBooked: false,
      eventId: 'muscle',
      image:
        'https://a.storyblok.com/f/282702/500x500/d6547f0d77/flex-wheeler.jpg',
    },
    // Dubai Muscle Talks Sessions - Day 3 (October 26, 2025)
    {
      id: 'dmt-5',
      title: 'Interview with Andrei Deiu',
      description:
        "A Romanian-born Men's Physique competitor and fitness model who earned his pro card in 2017, won the Romania Muscle Fest Pro, and has since built a strong presence both on stage and social media.",
      startTime: '13:30',
      endTime: '14:30',
      date: 'October 26, 2025',
      location: 'Dubai Muscle Talks Stage',
      feature: 'muscle-talks',
      category: 'Bodybuilding',
      isBooked: false,
      eventId: 'muscle',
      image:
        'https://a.storyblok.com/f/282702/500x500/16d5f000cd/andrei-deiu.jpg',
    },
    {
      id: 'dmt-6',
      title: 'Interview with Kevin Levrone',
      description:
        'An American IFBB legend from the \'90s-2000s era, with multiple major contest wins (including the Arnold Classic) and a record of four second-place finishes at Mr Olympia, earning him the "uncrowned" title.',
      startTime: '14:30',
      endTime: '15:30',
      date: 'October 26, 2025',
      location: 'Dubai Muscle Talks Stage',
      feature: 'muscle-talks',
      category: 'Bodybuilding',
      isBooked: false,
      eventId: 'muscle',
      image:
        'https://a.storyblok.com/f/282702/500x500/dd5a00addc/kevin-levrone.jpg',
    },
    {
      id: 'dmt-7',
      title: 'Interview with Ryan Terry',
      description:
        "A British Men's Physique athlete who finally broke through to win the Mr Olympia Men's Physique title, his 3rd consecutive, Mr. Olympia Men's Physique title, after many years of high-level competition.",
      startTime: '16:30',
      endTime: '17:30',
      date: 'October 26, 2025',
      location: 'Dubai Muscle Talks Stage',
      feature: 'muscle-talks',
      category: 'Bodybuilding',
      isBooked: false,
      eventId: 'muscle',
      image:
        'https://a.storyblok.com/f/282702/1000x1000/424be652fd/ryanterry.jpg',
    },
    // Dubai Active Industry - ME Fitness Business Summit - UPDATED TO OCTOBER 24
    {
      id: 'ceo-1',
      title: 'Welcoming Note',
      description: '',
      startTime: '10:15',
      endTime: '10:20',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
    },
    {
      id: 'ceo-2',
      title: 'Opening Keynote by Dubai Fitness Challenge',
      description: '',
      startTime: '10:20',
      endTime: '10:30',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Ahmed Al Khaja',
          title:
            'CEO, Dubai Festivals and Retail Establishment (DFRE) at Dubai Tourism',
          image:
            'https://a.storyblok.com/f/282702/500x500/17bb99fdad/ahmed-al-khaja.jpg',
        },
      ],
    },
    {
      id: 'ceo-3',
      title:
        'Opening Dialogue: The Future of Fitness: Building a Healthier Nation Through Public-Private Collaboration',
      description:
        'This panel explores the significant impact that fitness and wellness initiatives have on economic growth, societal well-being, and national competitiveness.',
      startTime: '10:30',
      endTime: '11:00',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      moderator: 'Cedric Betis',
      speakers: [
        {
          name: 'Ahmed Al Khaja',
          title:
            'CEO, Dubai Festivals and Retail Establishment (DFRE) at Dubai Tourism',
          image:
            'https://a.storyblok.com/f/282702/500x500/17bb99fdad/ahmed-al-khaja.jpg',
        },
        {
          name: 'Dr. Dimitri Koutsoubakis',
          title: 'CEO KUN Sports, Former CEO for One Fit Holding and Wellfit',
          image:
            'https://a.storyblok.com/f/282702/500x500/0d426c4ce7/dimitri.png',
        },
        {
          name: 'Cedric Betis',
          title: 'Wellness Consultant, Dubai Future Foundation',
          image:
            'https://a.storyblok.com/f/282702/500x500/efb6e6555d/cedric.jpg',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'ceo-4',
      title:
        "It's never been a better time to invest in fitness, health & wellness franchising",
      description:
        'A deep dive into the shift toward holistic, preventative health care, the role of fitness in long-term wellness, and why franchise investment is accelerating.',
      startTime: '11:00',
      endTime: '11:30',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Sander van den Born',
          title: 'Executive Vice President, International, Self Esteem Brands',
          image:
            'https://a.storyblok.com/f/282702/500x500/c77946bc41/sander-van.jpg',
        },
      ],
    },
    {
      id: 'ceo-5',
      title: 'Fitness Business Investment Dialogue',
      description:
        'A discussion between investors, founders, and operators exploring investment opportunities, growth strategies, and execution challenges in the fitness sector.',
      startTime: '11:30',
      endTime: '12:00',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Loren Holland',
          title: 'Founder and CEO, GymNation',
          image:
            'https://a.storyblok.com/f/282702/500x500/a41b76ca4a/loren.jpg',
        },
        {
          name: 'Manoj Asnani',
          title: 'Managing Director, J.P. Morgan',
          image:
            'https://a.storyblok.com/f/282702/500x500/cfc32aa6fa/manoj-prof.jpg',
        },
        {
          name: 'Tarek Mounir',
          title: 'CEO and Founder, Enhance Fitness',
          image:
            'https://a.storyblok.com/f/282702/500x500/2b16b3f108/tarek-mounir.jpg',
        },
        {
          name: 'Said Murad',
          title: 'Senior Partner, Global Ventures',
          image:
            'https://a.storyblok.com/f/282702/500x500/a867105fb3/said-murad.jpg',
        },
      ],
    },
    {
      id: 'ceo-6',
      title:
        'Sustainable Success: Developing People, Profits and Planet-Friendly Practices',
      description:
        'How fitness businesses can balance growth with innovation, people development, and environmental responsibility.',
      startTime: '12:00',
      endTime: '12:20',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Jenny Patrickson',
          title: 'Managing Director, Active IQ',
          image:
            'https://a.storyblok.com/f/282702/500x500/4b36eb3c73/jenny-patrickson.jpg',
        },
        {
          name: 'Gavin Baxter',
          title: 'Commercial Director, IEG Middle East',
          image:
            'https://a.storyblok.com/f/282702/500x500/cf768ae866/gavin-baxter.jpg',
        },
      ],
    },
    {
      id: 'ceo-7',
      title:
        'Bridge the gap between Artificial Intelligence and Emotional Connection',
      description:
        'Exploring how AI can deepen emotional connection in a people-first fitness industry while enhancing service and personalisation.',
      startTime: '12:20',
      endTime: '12:40',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Fabrizio Cecchinelli',
          title: 'Chief Training Experience Officer, Technogym',
          image:
            'https://a.storyblok.com/f/282702/500x500/2f879422ca/fabrizio-cecchinelli.jpg',
        },
      ],
    },
    {
      id: 'ceo-8',
      title: 'VIP Lunch and Networking',
      description: '',
      startTime: '12:40',
      endTime: '14:00',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
    },
    {
      id: 'ceo-9',
      title: 'The Gym Group Story – its Growth Journey and Next Chapter',
      description:
        'Lessons from the transformation of The Gym Group into a publicly listed fitness company, covering business model, retention, and strategic expansion.',
      startTime: '14:00',
      endTime: '14:45',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'John Treharne',
          title: 'Founder and Chair, The Gym Group',
          image:
            'https://a.storyblok.com/f/282702/500x500/454a5a76da/john-treharne.jpg',
        },
      ],
    },
    {
      id: 'ceo-10',
      title:
        'From Predictions to Performance: Leveraging AI in the Fitness Industry',
      description:
        'How AI-powered personalisation, smart equipment, and real-time data tracking are reshaping training, engagement, and performance.',
      startTime: '14:45',
      endTime: '15:15',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Marcin Obel',
          title: 'Founder & Chief Innovation Officer',
          image:
            'https://a.storyblok.com/f/282702/500x500/36bc713135/marcin.png',
        },
        {
          name: 'Karl Foster',
          title: 'Chief Technology Officer, GymNation',
          image:
            'https://a.storyblok.com/f/282702/500x500/9b99e36a32/karl-foster.jpg',
        },
        {
          name: 'Peter Croft',
          title: 'VP Alliances & Partnerships, Sport Alliance',
          image:
            'https://a.storyblok.com/f/282702/500x500/8fa8585432/peter-croft.jpg',
        },
        {
          name: 'Dan Duran',
          title: 'Chairman, REX Roundtables for Executives',
          image:
            'https://a.storyblok.com/f/282702/500x500/55bc20ee1d/dan-duran.jpg',
        },
      ],
    },
    {
      id: 'ceo-11',
      title:
        'Unlocking Regional Success: Strategies for Expanding Beyond the UAE',
      description:
        'A practical look at regional expansion: market research, localisation, partnerships, talent, finance, tech, and sustainability.',
      startTime: '15:15',
      endTime: '15:45',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      moderator: 'Rachel Young',
      speakers: [
        {
          name: 'Muhammed Saley',
          title: 'General Manager, Al Khayyat Investments (KSA) - Befit',
          image:
            'https://a.storyblok.com/f/282702/500x500/9ff2d8e417/mohummed-saley.jpg',
        },
        {
          name: 'Tom Foley',
          title: 'CEO, GO Sport',
          image:
            'https://a.storyblok.com/f/282702/500x500/df67fc4e11/tom-foley.jpg',
        },
        {
          name: 'Wajdan Gul',
          title: 'CEO and Founder, SQUATWOLF',
          image:
            'https://a.storyblok.com/f/282702/500x500/f6f8272bf3/wajdan-gul.jpg',
        },
        {
          name: 'Rachel Young',
          title: 'Chair',
          image:
            'https://a.storyblok.com/f/282702/500x500/93dbe3b042/rachel-young.gif',
          role: 'Chair',
        },
        {
          name: 'Suzelle Snowden',
          title: 'President, Fit Bodies Inc',
          image:
            'https://a.storyblok.com/f/282702/500x500/2110466c6e/suzelle_fitbodies.jpg',
        },
      ],
    },
    {
      id: 'ceo-12',
      title: 'From Concept to Global Phenomenon: The HYROX Story',
      description:
        'Christian Toetzke, Co-founder & CEO of HYROX, shares the journey of creating and scaling HYROX into a global fitness competition brand.',
      startTime: '15:45',
      endTime: '16:30',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Christian Toetzke',
          title: 'Co-Founder and CEO, HYROX',
          image:
            'https://a.storyblok.com/f/282702/500x500/42e4d5e841/christian-toetzke.jpg',
        },
        {
          name: 'Hamza Gherara',
          title: 'Founder, GHM Consultancy',
          image:
            'https://a.storyblok.com/f/282702/500x500/806a49905b/hamza-gherara.jpg',
        },
      ],
    },
    {
      id: 'ceo-13',
      title: 'Outlook Report: Future of Fitness and Wellness',
      description:
        'Data-driven insights into global fitness and wellness trends, presented by Colliers and SPA Connectors.',
      startTime: '16:30',
      endTime: '16:55',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Nicolas Nasra',
          title: 'Head of Hotel Advisory, Colliers in MENA',
          image:
            'https://a.storyblok.com/f/282702/500x500/624b9c2abc/nicolas-nasra.jpg',
        },
        {
          name: 'Kathryn Moore',
          title: 'Founder and Managing Director, Spa Connectors',
          image:
            'https://a.storyblok.com/f/282702/500x500/d2ff1d03a4/kathryn-moore.jpg',
        },
      ],
    },
    {
      id: 'ceo-14',
      title: 'End of Forum',
      description: '',
      startTime: '16:55',
      endTime: '17:00',
      date: 'October 24, 2025',
      location: 'CEO Forum',
      feature: 'me-fitness',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
    },
    // Future Wellness Summit Sessions - UPDATED TO OCTOBER 24
    {
      id: 'fws-1',
      title: 'Middle East Future Wellness Outlook',
      description: '',
      startTime: '10:30',
      endTime: '10:45',
      date: 'October 24, 2025',
      location: 'Future Wellness Summit',
      feature: 'future-wellness',
      category: 'Wellness',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Kathryn Moore',
          title: 'Founder and Managing Director, Spa Connectors',
          image:
            'https://a.storyblok.com/f/282702/500x500/d2ff1d03a4/kathryn-moore.jpg',
        },
      ],
    },
    {
      id: 'fws-2',
      title:
        'Turning Vision into Reality: Addressing Wellness Challenges in Middle East Hospitality Development',
      description: '',
      startTime: '10:45',
      endTime: '11:20',
      date: 'October 24, 2025',
      location: 'Future Wellness Summit',
      feature: 'future-wellness',
      category: 'Wellness',
      isBooked: false,
      eventId: 'industry',
      moderator: 'Kathryn Moore',
      speakers: [
        {
          name: 'Simon Hasdell',
          title:
            'Vice President - Hospitality Asset Management, IFA Hotels & Resorts',
          image:
            'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
        },
        {
          name: 'Lindsay Madden-Nadeau',
          title:
            'Senior Director of Wellness Strategy and Development, Red Sea Global',
          image:
            'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
        },
        {
          name: 'James Hewitson',
          title: 'General Manager, Anantara The Palm Dubai Resort',
          image:
            'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
        },
        {
          name: 'Kathryn Moore',
          title: 'Founder and Managing Director, Spa Connectors',
          image:
            'https://a.storyblok.com/f/282702/500x500/d2ff1d03a4/kathryn-moore.jpg',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'fws-3',
      title:
        'Maximising Wellness Talent: Retaining the Best for your Business in the Middle East',
      description: '',
      startTime: '11:20',
      endTime: '12:05',
      date: 'October 24, 2025',
      location: 'Future Wellness Summit',
      feature: 'future-wellness',
      category: 'Wellness',
      isBooked: false,
      eventId: 'industry',
      moderator: 'Tajana Trtanj',
      speakers: [
        {
          name: 'Gary Blowers',
          title: 'Founder and CEO, LVL Wellbeing',
          image:
            'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
        },
        {
          name: 'Sharon Barcock',
          title: 'Director of Spa Operations & Development MEA, Hilton',
          image:
            'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
        },
        {
          name: 'Lauren Henry',
          title: 'Founder and Managing Director, Spa Recruit ME',
          image:
            'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop',
        },
        {
          name: 'Tajana Trtanj',
          title: 'Business Development Director, EPI Wellness',
          image:
            'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'fws-4',
      title: 'Exploring the Next Frontier in Wellness Experiences',
      description: '',
      startTime: '12:05',
      endTime: '12:50',
      date: 'October 24, 2025',
      location: 'Future Wellness Summit',
      feature: 'future-wellness',
      category: 'Wellness',
      isBooked: false,
      eventId: 'industry',
      moderator: 'Daniella Russell',
      speakers: [
        {
          name: 'Sara Codner',
          title:
            'Area Director of Spa & Wellness, Middle East, Mandarin Oriental Downtown, Dubai',
          image:
            'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop',
        },
        {
          name: 'Heidi Grimwood',
          title:
            'Vice President, Atmosphere Wellness Pvt. Ltd, Elena Spa Company',
          image:
            'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop',
        },
        {
          name: 'Amanda Schmiege',
          title:
            'Senior Director of Spa and Wellness, Four Seasons Hotel and Resorts',
          image:
            'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop',
        },
        {
          name: 'Daniella Russell',
          title: 'Managing Director, DR Global',
          image:
            'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'fws-5',
      title: 'Revolutionising Wellness: Innovations in Health Tech',
      description: '',
      startTime: '12:50',
      endTime: '13:25',
      date: 'October 24, 2025',
      location: 'Future Wellness Summit',
      feature: 'future-wellness',
      category: 'Wellness',
      isBooked: false,
      eventId: 'industry',
      moderator: 'Paulina Mercader',
      speakers: [
        {
          name: 'Sammy Gharieni',
          title: 'Founder & CEO, Gharieni Group',
          image:
            'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop',
        },
        {
          name: 'Hamdan Al Khafaji',
          title: 'Founder, Contrast Wellness',
          image:
            'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
        },
        {
          name: 'Yona Shtern',
          title: 'CEO, Hapbee',
          image:
            'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop',
        },
        {
          name: 'Paulina Mercader',
          title: 'CEO GCC, The Longevity Suite',
          image:
            'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'fws-6',
      title:
        'The Future of Healthcare and its Impact on Wellness Businesses for Middle East Consumers',
      description: '',
      startTime: '13:25',
      endTime: '13:55',
      date: 'October 24, 2025',
      location: 'Future Wellness Summit',
      feature: 'future-wellness',
      category: 'Wellness',
      isBooked: false,
      eventId: 'industry',
      moderator: 'Mahi Aramideh',
      speakers: [
        {
          name: 'Dr. Muhammad Tahir',
          title:
            'Consultant Psychiatrist, Wellness Coach, Trainer, Director and Founder of American Wellness Center',
          image:
            'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop',
        },
        {
          name: 'Dr. Umair Qureshi',
          title:
            'Physician, The Brain & Performance Centre - A DP World Company',
          image:
            'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=400&h=400&fit=crop',
        },
        {
          name: 'Dr. Harjit Bahia',
          title:
            'Founder and CEO, LONGEVITY-UK and Co-Founder and Chief Medical Officer, ZOI-ME',
          image:
            'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&h=400&fit=crop',
        },
        {
          name: 'Stephen Julius Delpino',
          title: 'Head - International Business Expansion, Meals On Me',
          image:
            'https://a.storyblok.com/f/282702/500x500/184d7b0831/untitled-design-42.png',
        },
        {
          name: 'Mahi Aramideh',
          title: 'Co-Founder and Director, The Elixir Clinic',
          image:
            'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'fws-7',
      title:
        "Global Wellness Strategies: Insights from Niamh O'Connell of Jumeirah and Kent Richards of Six Senses",
      description: '',
      startTime: '13:55',
      endTime: '14:25',
      date: 'October 24, 2025',
      location: 'Future Wellness Summit',
      feature: 'future-wellness',
      category: 'Wellness',
      isBooked: false,
      eventId: 'industry',
      moderator: 'Kathryn Moore',
      speakers: [
        {
          name: 'Kent Richards',
          title: 'Corporate Director of Operations, Six Senses Spas',
          image:
            'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
        },
        {
          name: "Niamh O'Connell",
          title: 'Group Vice President of Wellbeing, Jumeirah Hotels & Resorts',
          image:
            'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop',
        },
        {
          name: 'Kathryn Moore',
          title: 'Founder and Managing Director, Spa Connectors',
          image:
            'https://a.storyblok.com/f/282702/500x500/d2ff1d03a4/kathryn-moore.jpg',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'fws-8',
      title:
        'Balancing Minds and Bodies: The Intersection of Mental Health and Holistic Wellbeing',
      description: '',
      startTime: '14:25',
      endTime: '14:55',
      date: 'October 24, 2025',
      location: 'Future Wellness Summit',
      feature: 'future-wellness',
      category: 'Wellness',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Linda Sakr',
          title: 'Holistic Psychologist and Founder of Keyani Wellness',
          image:
            'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop',
        },
      ],
    },
    {
      id: 'fws-9',
      title:
        'Biohacking, Alternative Wellness and the Future of Wellness Offerings',
      description: '',
      startTime: '14:55',
      endTime: '15:40',
      date: 'October 24, 2025',
      location: 'Future Wellness Summit',
      feature: 'future-wellness',
      category: 'Wellness',
      isBooked: false,
      eventId: 'industry',
      moderator: 'Sophia Delavari',
      speakers: [
        {
          name: 'Mary Cristine',
          title: 'Founder and CEO, BeThatLife',
          image:
            'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop',
        },
        {
          name: 'Dr. Elie Abirached',
          title:
            'Biohacking & Recovery Strategist, CEO of Restore Fitness, Founder of Limitless Human',
          image:
            'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop',
        },
        {
          name: 'James Jones',
          title: 'Head Coach, Formation',
          image:
            'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
        },
        {
          name: 'Jessica Casalegno',
          title: 'Wellness Director, DRYP',
          image:
            'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop',
        },
        {
          name: 'Sophia Delavari',
          title: 'Executive Manager, Coach and Host of "The Detached Podcast"',
          image:
            'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'fws-10',
      title:
        'The Importance of a Personalised Supplement Amid a One-Size-Fits-All Market',
      description: '',
      startTime: '15:40',
      endTime: '16:00',
      date: 'October 24, 2025',
      location: 'Future Wellness Summit',
      feature: 'future-wellness',
      category: 'Wellness',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Vadim Fedotov',
          title: 'Founder and CEO, Bioniq',
          image:
            'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'fws-11',
      title: 'Workplace Wellbeing Initiatives: Where are we at now?',
      description: '',
      startTime: '16:00',
      endTime: '16:45',
      date: 'October 24, 2025',
      location: 'Future Wellness Summit',
      feature: 'future-wellness',
      category: 'Wellness',
      isBooked: false,
      eventId: 'industry',
      moderator: 'Rachel Dowes',
      speakers: [
        {
          name: 'Maria Haggo',
          title: 'Founder and CEO, Transform8',
          image:
            'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop',
        },
        {
          name: 'Gayu Lewis',
          title: 'Wellness Advocate, Holistic Coach and Founder of the F Coach',
          image:
            'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop',
        },
        {
          name: 'Sudha Sripada',
          title: 'Wellbeing Advisor, Heriot-Watt Dubai University',
          image:
            'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop',
        },
        {
          name: 'Denny Jose',
          title:
            'Director of People & Culture, Agile HC. Former Employee Experience Team leader, ADNOC Distribution, UAE',
          image:
            'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
        },
        {
          name: 'Rachel Dowes',
          title: 'Owner, Beyond Transformation',
          image:
            'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    // XPRO Summit Sessions - Day 1 (October 25, 2025)
    {
      id: 'xpro-1',
      title:
        "Insights and Trends: Key Findings from the 'Working in Fitness' Survey, UAE",
      description:
        'Comprehensive analysis of the fitness industry workforce in the UAE, revealing key trends, challenges, and opportunities for fitness professionals.',
      startTime: '10:30',
      endTime: '11:00',
      date: 'October 25, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Speaker TBA',
          title: 'Presenter',
          image:
            'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-2',
      title: 'Fitness and The Entrepreneurial Roadmap',
      description:
        'Navigate the journey from fitness professional to successful entrepreneur. Learn the essential steps, strategies, and mindset shifts needed to build a thriving fitness business.',
      startTime: '11:00',
      endTime: '12:00',
      date: 'October 25, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Speaker TBA',
          title: 'Presenter',
          image:
            'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
        {
          name: 'Moderator TBA',
          title: 'Moderator',
          image:
            'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'xpro-3',
      title:
        '$160M+ in Online Coaching Revenue: Navigating the Peaks and Valleys of Fitness Entrepreneurship',
      description:
        'Industry leaders share their experiences building multi-million dollar online coaching businesses, discussing the challenges, breakthroughs, and lessons learned along the way.',
      startTime: '12:00',
      endTime: '13:00',
      date: 'October 25, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'John Franich',
          title: 'Co-Founder, MacroActive',
          image:
            'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
        },
        {
          name: 'Panelist TBA',
          title: 'Panelist',
          image:
            'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
        },
        {
          name: 'Gareth Manger',
          title: 'Chief Revenue Officer, MacroActive',
          image:
            'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'xpro-4',
      title:
        'The Evolution of Gamification in Fitness and Training - 1 CPD Point',
      description:
        'Explore how gamification is transforming the fitness industry, from engagement strategies to performance tracking. Earn 1 CPD point by attending this session.',
      startTime: '13:00',
      endTime: '14:00',
      date: 'October 25, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Marwan Albanna',
          title: 'Master Trainer, Veo by Emaar Hospitality Group',
          image:
            'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
        },
        {
          name: 'Danny Bartlett',
          title: 'Senior Master Trainer, TRX and Head Tutor, ISSA Middle East',
          image:
            'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop',
        },
        {
          name: 'Ben Davis',
          title: 'Head of Operations, Champs Training Fitness Group (F45)',
          image:
            'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop',
        },
        {
          name: 'Moderator TBA',
          title: 'Moderator',
          image:
            'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'xpro-5',
      title:
        'Navigating the Pilates Landscape: Exploring Trends, Classical vs. Contemporary Approaches, and Future Pathways - 1 CPD Point',
      description:
        'Deep dive into the Pilates industry, examining traditional and modern approaches, current trends, and future opportunities for Pilates professionals. Earn 1 CPD point.',
      startTime: '14:00',
      endTime: '15:00',
      date: 'October 25, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Heba Abdel Gawad',
          title: 'Co-Founder and Head of Education, .body//HACK',
          image:
            'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-6',
      title: 'From Trainer to Gym Founder: Believing in your WHY',
      description:
        'Inspirational journey from personal trainer to gym owner, focusing on finding your purpose, building your vision, and creating a successful fitness business.',
      startTime: '15:00',
      endTime: '16:00',
      date: 'October 25, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Kevin Teixeira',
          title: 'Founder and CEO, The Warehouse Gym',
          image:
            'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
        {
          name: 'Moderator TBA',
          title: 'Moderator',
          image:
            'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
          role: 'Moderator',
        },
      ],
    },
    {
      id: 'xpro-7',
      title:
        'The Gut-Brain Connection: Probiotics, Microbiota, and Their Impact on Health - 1 CPD Point',
      description:
        'Scientific exploration of the gut-brain axis, examining how probiotics and microbiota influence overall health, mental wellbeing, and athletic performance. Earn 1 CPD point.',
      startTime: '16:00',
      endTime: '17:00',
      date: 'October 25, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Nathalie Jabrayan',
          title: 'Head of Nutrition, Enhance Fitness',
          image:
            'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    // XPRO Summit Sessions - Day 2 (October 26, 2025)
    {
      id: 'xpro-8',
      title: 'Youth Sport Development, Education, and Pathways',
      description:
        'Comprehensive look at youth sports development, educational frameworks, and career pathways for young athletes in the Middle East.',
      startTime: '10:30',
      endTime: '11:00',
      date: 'October 26, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Nigel Prasad',
          title:
            'Managing Partner, Alternate A and Senior Sports Advisor, Talentlockr',
          image:
            'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
          role: 'Host',
        },
      ],
    },
    {
      id: 'xpro-9',
      title:
        'Long-Term Succession Planning - Moving the Workforce from International Placements to Emirati Citizens',
      description:
        'Strategic insights on workforce localization in the UAE fitness industry, focusing on developing Emirati talent and creating sustainable career pathways.',
      startTime: '11:00',
      endTime: '12:00',
      date: 'October 26, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Aaron McCulloch',
          title: 'Co-Owner & Director, Your Personal Training',
          image:
            'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-10',
      title: 'Secrets to Pivoting: From Gym Owners to Education',
      description:
        'Learn from successful gym owners who transitioned into fitness education, sharing their strategies, challenges, and insights on building education businesses.',
      startTime: '12:00',
      endTime: '13:00',
      date: 'October 26, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Steven Dick',
          title: 'Co-Founder, The Fitness Group Education',
          image:
            'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
        {
          name: 'Scott Agnew',
          title: 'Co-Founder, The Fitness Group Education',
          image:
            'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-11',
      title:
        'New Accreditation and Education and the Opportunities for your Training Career',
      description:
        'Panel discussion on emerging accreditation standards, educational opportunities, and how they can accelerate your fitness training career in the Middle East.',
      startTime: '13:00',
      endTime: '14:00',
      date: 'October 26, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Panelist TBA',
          title: 'Panelist',
          image:
            'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
        },
        {
          name: 'Panelist TBA',
          title: 'Panelist',
          image:
            'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
        },
        {
          name: 'Haya Sawan',
          title: 'Managing Director, Motion Academy',
          image:
            'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
        },
        {
          name: 'Panelist TBA',
          title: 'Panelist',
          image:
            'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
        },
        {
          name: 'Presenter TBA',
          title: 'Presenter',
          image:
            'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-12',
      title:
        'Scaling Essentials for High Value and High Earning Online Coaching Brands in 2025 - 1 CPD Point',
      description:
        'Master the fundamentals of scaling online coaching businesses, from pricing strategies to client acquisition and retention. Earn 1 CPD point.',
      startTime: '14:00',
      endTime: '15:00',
      date: 'October 26, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Mark Coles',
          title: 'Founder and CEO, Coaching Concierge',
          image:
            'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-13',
      title: 'Expanding your Training Profession in Saudi Arabia',
      description:
        'Explore opportunities for fitness professionals in Saudi Arabia, including market insights, regulatory requirements, and strategies for successful expansion.',
      startTime: '15:00',
      endTime: '16:00',
      date: 'October 26, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Shimaa Adel Elharony',
          title: 'Managing Director, Motion Academy',
          image:
            'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-14',
      title:
        'Rapid Fat Loss Strategies for Industry-leading Client Transformations - 1 CPD Point',
      description:
        'Evidence-based fat loss strategies used by top coaches to achieve remarkable client transformations. Learn practical, sustainable approaches. Earn 1 CPD point.',
      startTime: '16:00',
      endTime: '17:00',
      date: 'October 26, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Martin MacDonald',
          title: 'CEO and Founder, Mac-Nutrition Uni',
          image:
            'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    // XPRO Summit Sessions - Day 3 (October 27, 2025)
    {
      id: 'xpro-15',
      title:
        'The Essentials of Scaling an Online Coaching Business: My Journey to Achieving 5X Growth in Online Coaching in Just 6 Months!',
      description:
        'Real-world case study of rapid online coaching business growth, sharing actionable strategies, tools, and mindset shifts that led to 5X growth in 6 months.',
      startTime: '10:30',
      endTime: '11:00',
      date: 'October 27, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Business',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Karim Gabriel',
          title: 'Founder, KG Workouts',
          image:
            'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-16',
      title:
        'Beyond Teaching: Hacks to Master Excellency in your Yoga Career - 1 CPD Point',
      description:
        'Elevate your yoga career beyond the mat. Learn business strategies, personal branding, and professional development tactics from a Guinness World Record holder. Earn 1 CPD point.',
      startTime: '11:00',
      endTime: '12:00',
      date: 'October 27, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Yash Moradiya',
          title: '10x Guinness World Record Holder, Yogipreneur',
          image:
            'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-17',
      title: 'HYROX Training - Revolutionising Fitness - 1 CPD Point',
      description:
        "Discover the HYROX training methodology that's transforming functional fitness worldwide. Learn programming, coaching techniques, and business opportunities. Earn 1 CPD point.",
      startTime: '12:00',
      endTime: '13:00',
      date: 'October 27, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'David Magida',
          title: 'Global Head of Training, HYROX 365',
          image:
            'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-18',
      title:
        "Evolution of the Fitness Industry and Pioneering Tomorrow's Trends",
      description:
        "Panel discussion on the fitness industry's evolution, current disruptions, and emerging trends that will shape the future of fitness education and training.",
      startTime: '13:00',
      endTime: '14:00',
      date: 'October 27, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Chris Dickey',
          title: 'Operations Manager, FIT College',
          image:
            'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
        {
          name: 'Dr. Mark McKean',
          title: 'Curriculum Development & Special Projects, FIT College',
          image:
            'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
        {
          name: 'Joshua Jones',
          title: 'Education Manager, FIT College',
          image:
            'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-19',
      title:
        'Before Movement, Understand Your Joints: Bridging the Gap and Highlighting the Crucial Role of Joint Training - 1 CPD Point',
      description:
        'Deep dive into joint health and mobility training, exploring the foundational importance of joint function in movement quality and injury prevention. Earn 1 CPD point.',
      startTime: '14:00',
      endTime: '15:00',
      date: 'October 27, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Ava Rodriguez',
          title: 'The joint whisperer, CEO & Founder, Mobility Fitness Academy',
          image:
            'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-20',
      title: 'The Rise of Specialised Training Programmes - 1 CPD Point',
      description:
        'Explore the growing demand for specialized training programs, from niche populations to specific outcomes. Learn how to develop and market specialized services. Earn 1 CPD point.',
      startTime: '15:00',
      endTime: '16:00',
      date: 'October 27, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Dr. Glenda Rivoallan',
          title: 'Founder and CEO, We Talk Wellbeing',
          image:
            'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop',
          role: 'Presenter',
        },
      ],
    },
    {
      id: 'xpro-21',
      title: 'Myzone: Beyond the screen - 1 CPD Point',
      description:
        'Maximize the potential of Myzone heart rate monitoring technology. Learn advanced coaching techniques, data interpretation, and client engagement strategies. Earn 1 CPD point.',
      startTime: '16:00',
      endTime: '17:00',
      date: 'October 27, 2025',
      location: 'XPRO Summit Stage',
      feature: 'xpro',
      category: 'Education',
      isBooked: false,
      eventId: 'industry',
      speakers: [
        {
          name: 'Rachel Young',
          title: 'Host',
          image:
            'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
          role: 'Host',
        },
      ],
    },
  ]
